module.exports = __webpack_public_path__ + "static/WFS-Logo_Dark-d49c537d82d122c98a51204e39c2aedf.png";